class menuHelper {
    constructor(el) {
    }

    toggle(el) {
        el.addEventListener('click', (_el) => {

            if (document.body.classList.contains('menu-is-active')) {
                document.body.classList.remove('menu-is-shown');
                setTimeout(function () {
                        document.body.classList.remove('menu-is-active');
                    },
                    101
                );
            } else {
                document.body.classList.add('menu-is-active');
                setTimeout(function () {
                        document.body.classList.add('menu-is-shown');
                    },
                    1
                );
            }
        });
    }

    internalToggle(el) {
        el.addEventListener('click', (e) => {
            e.preventDefault();


            if(el.classList.contains('is-active')) {

                var subMenuLinks = document.querySelectorAll('.sub-menu-link');

                subMenuLinks.forEach(function (link, index) {
                    console.log('link', link);
                    link.classList.remove('is-active');
                });


                var subMenus = document.querySelectorAll('.ruf__master-menu__sub-menu');

                subMenus.forEach(function (menu, index) {
                    menu.classList.remove('is-active');
                });

            } else {

                var subMenuLinks = document.querySelectorAll('.sub-menu-link');

                subMenuLinks.forEach(function (link, index) {
                    console.log('link', link);
                    link.classList.remove('is-active');
                });

                el.classList.add('is-active');

                var subMenus = document.querySelectorAll('.ruf__master-menu__sub-menu');

                subMenus.forEach(function (menu, index) {
                    menu.classList.remove('is-active');
                });

                document.getElementById('sub-menu-' + el.dataset.target).classList.add('is-active');

            }

        });
    }

}

window.app.add('menu', new menuHelper());